import { ProductRatingService } from './../../../../../providers/services/product-rating.service';
import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { WishilistService } from '../../../../../providers/services/wishilist.service';
import { CartService } from '../../../../../providers/services/cart.service';
import { ProductService } from '../../../../../providers/services/product.service';
import { AbstractProductItem } from '../abstract-product-item';
import { MatDialog } from '@angular/material/dialog';
import { NgIf, NgFor, CurrencyPipe } from '@angular/common';
import { BarRatingModule } from 'ngx-bar-rating';

@Component({
    selector: 'pdp-product-box-vertical-two',
    templateUrl: './product-box-vertical-two.component.html',
    styleUrls: ['./product-box-vertical-two.component.scss'],
    imports: [RouterLink, NgIf, BarRatingModule, NgFor, CurrencyPipe]
})
export class ProductBoxVerticalTwoComponent extends AbstractProductItem {


  constructor(public router: Router, 
              public activatedRoute: ActivatedRoute,
              public productsService: ProductService,
              public wishlistService: WishilistService, 
              public cartService: CartService,
              public dialog: MatDialog,
              public ratingService: ProductRatingService) { 
        super(router, activatedRoute, productsService, wishlistService, cartService, dialog, ratingService);
  }
}
